import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PowerIcon(props: IconProps) {
    return <Icon {...props} iconKey={"power"}/>
}
